import React, { useEffect } from 'react';
import './App.css';

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation
} from "react-router-dom"

import Home from "./components/Home"
import RestaurantCreate from "./components/RestaurantCreate"
import RestaurantList from "./components/RestaurantList"
import Logout from "./components/Logout"
import RestaurantUpdate from "./components/RestaurantUpdate"
import Login from './components/Login';
import Register from './components/Register';

import DonationList from "./components/DonationList"
import DonationCreate from "./components/DonationCreate"
import DonationUpdate from "./components/DonationUpdate"

import UserList from "./components/UserList"
import UserCreate from "./components/UserCreate"
import UserUpdate from "./components/UserUpdate"
import LiveDonationBoard from "./components/LiveDonationBoard"
import LiveDonationDisplay from "./components/LiveDonationDisplay"
import DonorRoomDisplay from "./components/DonorRoomDisplay"
import UserWiseStatistics from "./components/UserWiseStatistics"
import ContributionList from "./components/ContributionList"
import ContributionCreate from "./components/ContributionCreate"
import ContributionUpdate from "./components/ContributionUpdate"

import ExpenseList from "./components/ExpenseList"
import ExpenseCreate from "./components/ExpenseCreate"
import ExpenseUpdate from "./components/ExpenseUpdate"

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Global Route Guard Component - must be inside Router
const GlobalRouteGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Skip check for login and register pages
    if (location.pathname === '/login' || location.pathname === '/register') {
      return;
    }

    // Check if user is logged in
    const loginData = localStorage.getItem('login');
    if (loginData) {
      try {
        const user = JSON.parse(loginData);
        
        // If user role is 'user', logout immediately
        if (user.role === 'user') {
          localStorage.clear();
          toast.error('Access denied. You have been logged out.');
          navigate('/login');
        }
      } catch (error) {
        console.error('Error parsing user data:', error);
        // If there's an error parsing, clear localStorage and redirect
        localStorage.clear();
        navigate('/login');
      }
    }
  }, [location.pathname, navigate]);

  return children;
};

function AppContent() {
  return (
    <GlobalRouteGuard>
      <Routes>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/register" element={<Register />}></Route>
        <Route path="/" element={<Home />}></Route>
        <Route path="/list" element={<RestaurantList />}></Route>
        <Route path="/create/:id" element={<RestaurantCreate />}></Route>
        <Route path="/update/:id" element={<RestaurantUpdate />}></Route>
        <Route path="/logout" element={<Logout />}></Route>

        <Route path="/donation-list" element={<DonationList />}></Route>
        <Route path="/donation-create" element={<DonationCreate />}></Route>
        <Route path="/donation-update/:id" element={<DonationUpdate />}></Route>

        <Route path="/user-list" element={<UserList />}></Route>
        <Route path="/user-create" element={<UserCreate />}></Route>
        <Route path="/user-update/:id" element={<UserUpdate />}></Route>

        <Route path="/live-donation-board" element={<LiveDonationBoard />}></Route>
        <Route path="/live-donation-display" element={<LiveDonationDisplay />}></Route>
        <Route path="/donor-room-display" element={<DonorRoomDisplay />}></Route>
        <Route path="/user-wise-statistics" element={<UserWiseStatistics />}></Route>

        <Route path="/contribution-list" element={<ContributionList />}></Route>
        <Route path="/contribution-create" element={<ContributionCreate />}></Route>
        <Route path="/contribution-update/:id" element={<ContributionUpdate />}></Route>

        <Route path="/expense-list" element={<ExpenseList />}></Route>
        <Route path="/expense-create" element={<ExpenseCreate />}></Route>
        <Route path="/expense-update/:id" element={<ExpenseUpdate />}></Route>

      </Routes>
    </GlobalRouteGuard>
  );
}

function App() {
  return (
    <div>
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      <ToastContainer />
      <Router>
        <AppContent />
      </Router>

    </div>
  );
}

export default App;
